import { Credentials } from "auth";
import { Organization } from "generated/graphql";
import { Action } from "redux";

export type FetchOrganization = "FETCH_ORGANIZATION";
export const FETCH_ORGANIZATION: FetchOrganization = "FETCH_ORGANIZATION";
export type FetchOrganizationEnd = "FETCH_ORGANIZATION_END";
export const FETCH_ORGANIZATION_END: FetchOrganizationEnd = "FETCH_ORGANIZATION_END";

export interface FetchOrganizationAction extends Action {
    payload: {
        credentials: Credentials;
        organizationId: string;
        selectOnSuccess: boolean;
    };
    type: FetchOrganization;
}

export interface FetchOrganizationEndAction extends Action {
    payload: {
        organization?: Organization;
        error?: Error;
        selectOnSuccess: boolean;
    };
    type: FetchOrganizationEnd;
}

export function fetchOrganizationEnd(
    error: Error,
    organization?: Organization,
    selectOnSuccess?: boolean
): FetchOrganizationEndAction {
    return {
        payload: {
            error,
            organization,
            selectOnSuccess
        },
        type: FETCH_ORGANIZATION_END
    };
}
